var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCombo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 41,
    viewBox: "0 0 57 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3366_4268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8066 40.1347H4.80664V5.34467C4.80664 5.23467 4.96664 5.13467 5.17664 5.13467H13.4366C13.6466 5.13467 13.8066 5.23467 13.8066 5.34467V40.1347Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6866 40.1347H17.6866V12.3947C17.6866 12.2547 17.8666 12.1347 18.0966 12.1347H27.2766C27.5066 12.1347 27.6866 12.2547 27.6866 12.3947V40.1347Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0067 40.1347H31.7367V23.1347C31.7367 22.9947 31.9067 22.8947 32.1167 22.8947H40.6267C40.8367 22.8947 41.0067 22.9947 41.0067 23.1347V40.1347Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0566 40.1347H45.0566V12.7347C45.0566 12.4047 45.2166 12.1347 45.4266 12.1347H53.6866C53.8966 12.1347 54.0566 12.4047 54.0566 12.7347V40.1347Z",
    fill: "#003F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.806641 40.1347H56.8066",
    stroke: "#2B2B35",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3667 31.5047L22.3667 21.7147L8.70667 19.3247L8.88666 18.1347L22.8067 20.5747L36.3667 30.0347L49.0467 19.8447L49.7067 20.8447L36.3667 31.5047Z",
    fill: "#0298A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30666 20.9247C9.72201 20.9247 10.128 20.8015 10.4734 20.5708C10.8187 20.34 11.0879 20.0121 11.2468 19.6283C11.4058 19.2446 11.4473 18.8224 11.3663 18.415C11.2853 18.0077 11.0853 17.6335 10.7916 17.3398C10.4979 17.0461 10.1237 16.8461 9.71635 16.7651C9.30899 16.684 8.88675 16.7256 8.50303 16.8846C8.11931 17.0435 7.79133 17.3127 7.56058 17.658C7.32983 18.0033 7.20667 18.4094 7.20667 18.8247C7.20667 19.3817 7.42791 19.9158 7.82174 20.3096C8.21557 20.7035 8.74971 20.9247 9.30666 20.9247Z",
    fill: "#0298A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6867 23.3347C23.102 23.3347 23.508 23.2115 23.8534 22.9808C24.1987 22.75 24.4679 22.422 24.6268 22.0383C24.7858 21.6546 24.8273 21.2323 24.7463 20.825C24.6653 20.4176 24.4653 20.0434 24.1716 19.7498C23.8779 19.4561 23.5037 19.2561 23.0964 19.175C22.689 19.094 22.2668 19.1356 21.883 19.2945C21.4993 19.4535 21.1713 19.7226 20.9406 20.068C20.7098 20.4133 20.5867 20.8193 20.5867 21.2347C20.5867 21.5105 20.641 21.7835 20.7465 22.0383C20.8521 22.2931 21.0067 22.5246 21.2017 22.7196C21.3967 22.9146 21.6283 23.0693 21.883 23.1748C22.1378 23.2804 22.4109 23.3347 22.6867 23.3347Z",
    fill: "#0298A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2566 32.3347C36.672 32.3347 37.078 32.2115 37.4233 31.9808C37.7687 31.75 38.0378 31.422 38.1968 31.0383C38.3557 30.6546 38.3973 30.2323 38.3163 29.825C38.2352 29.4176 38.0352 29.0434 37.7415 28.7498C37.4479 28.4561 37.0737 28.2561 36.6663 28.175C36.2589 28.094 35.8367 28.1356 35.453 28.2945C35.0693 28.4535 34.7413 28.7226 34.5105 29.068C34.2798 29.4133 34.1566 29.8193 34.1566 30.2347C34.1566 30.7916 34.3779 31.3258 34.7717 31.7196C35.1655 32.1134 35.6997 32.3347 36.2566 32.3347Z",
    fill: "#0298A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5567 22.3347C49.972 22.3347 50.378 22.2115 50.7234 21.9808C51.0687 21.75 51.3379 21.422 51.4968 21.0383C51.6558 20.6546 51.6973 20.2323 51.6163 19.825C51.5353 19.4176 51.3353 19.0434 51.0416 18.7498C50.7479 18.4561 50.3737 18.2561 49.9664 18.175C49.559 18.094 49.1368 18.1356 48.753 18.2945C48.3693 18.4535 48.0413 18.7226 47.8106 19.068C47.5798 19.4133 47.4567 19.8193 47.4567 20.2347C47.4567 20.7916 47.6779 21.3258 48.0717 21.7196C48.4656 22.1134 48.9997 22.3347 49.5567 22.3347Z",
    fill: "#0298A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3366_4268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 40,
    fill: "white",
    transform: "translate(0.806641 0.134674)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombo);
export default __webpack_public_path__ + "static/media/combo.de2c6a1646b739b0386a94f9f6741839.svg";
export { ForwardRef as ReactComponent };